import React from 'react';
import { requestPasswordReset } from './customerSession';
import * as s from './portalStyles';
import PortalBrand from './PortalBrand';

/// Always shows the same confirmation, whether or not the address is known — mirroring the API,
/// which answers 204 either way. Telling someone "no account with that address" here would undo
/// the enumeration protection every other screen in the portal is built around.
export default function ForgotPassword({ onBack }) {
  const [email, setEmail] = React.useState('');
  const [sent, setSent] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  const [error, setError] = React.useState('');

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    setBusy(true);
    try {
      await requestPasswordReset(email);
      setSent(true);
    } catch (err) {
      // Only a transport or rate-limit failure can land here; the API doesn't report unknown
      // addresses as errors.
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={s.page}>
      <PortalBrand />
      <div style={s.subtitle}>Aumentum Technologies · Customer Portal</div>

      {sent ? (
        <>
          <div style={s.heading}>Check your email</div>
          <div style={s.helpText}>
            If <strong>{email}</strong> has an account, we've sent a link to reset the password.
            It's valid for two hours and can only be used once.
            <br />
            <br />
            Nothing arrived? Check your junk folder, then try again — or ask your Aumentum project
            manager to confirm which address your account uses.
          </div>
          <button type="button" style={s.linkButton} onClick={onBack}>
            Back to sign in
          </button>
        </>
      ) : (
        <>
          <div style={s.heading}>Reset your password</div>
          <div style={s.helpText}>
            Enter the email address you use to sign in and we'll send you a link to choose a new
            password.
          </div>
          {error && <div style={s.errorBox}>⚠ {error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label" htmlFor="forgot-email">Email address</label>
              <input
                id="forgot-email"
                className="form-input"
                type="email"
                autoComplete="username"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <button className="btn btn-primary" style={s.submitButton} type="submit" disabled={busy}>
              {busy ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
          <div style={s.footerRow}>
            <button type="button" style={s.linkButton} onClick={onBack}>
              Back to sign in
            </button>
          </div>
        </>
      )}
    </div>
  );
}
